import {
  DashboardOutlined,
  CameraOutlined,
  BellOutlined,
  BarChartOutlined,
  SafetyOutlined,
  HeatMapOutlined,
  CarOutlined,
  UserOutlined,
  ToolOutlined,
  EyeOutlined,
  TableOutlined
} from "@ant-design/icons";

export const pageRegistry = {

  dashboard: {
    title: "Dashboard",
    description: "Overview metrics and KPIs",
    icon: <DashboardOutlined />
  },

  camera: {
    title: "Camera",
    description: "Live camera monitoring",
    icon: <CameraOutlined />
  },

  alert: {
    title: "Alerts",
    description: "System alerts & violations",
    icon: <BellOutlined />
  },

  report: {
    title: "Reports",
    description: "Analytics & reports",
    icon: <BarChartOutlined />
  },

  analytics: {
    title: "Analytics",
    description: "Advanced insights & performance trends",
    icon: <BarChartOutlined />
  },

  compliance: {
    title: "Compliance",
    description: "PPE & regulation compliance tracking",
    icon: <SafetyOutlined />
  },

  heatmap: {
    title: "Heatmap",
    description: "Movement & zone heat analysis",
    icon: <HeatMapOutlined />
  },

  insights: {
    title: "Insights",
    description: "AI insights, recommendations and predictions",
    icon: <EyeOutlined />
  },

  maintenance: {
    title: "Maintenance",
    description: "Equipment health & maintenance status",
    icon: <ToolOutlined />
  },

  vehicle: {
    title: "Vehicle",
    description: "Vehicle logs & entry-exit monitoring",
    icon: <CarOutlined />
  },

  attendance: {
    title: "Attendance",
    description: "Presence & attendance tracking",
    icon: <UserOutlined />
  },
   "attendance-logs": {
    title: "Attendance Logs",
    description: "Staff entry and exit logs",
    icon: <TableOutlined />
  },

  "staff-summary": {
    title: "Staff Summary",
    description: "Staff entry and exit statistics",
    icon: <BarChartOutlined />
  }

};